import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import ButtonCard from '../../products/components/ButtonCard';
import { motion } from 'framer-motion';

const ProductCategoryCard = ({ product, onAddToCart, onAddToFavorites }) => {

  const navigate = useNavigate();

  const handleDetailClick = (row) => {

    Swal.fire({
      title: 'Loading Product Details...',
      text: 'Please wait while we fetch the product details.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    // Simulate delay (optional, remove if unnecessary)
    setTimeout(() => {
      Swal.close(); // Close loading popup
      navigate('/detail-product', { state: { row } });
    }, 1000); // Adjust time as needed (1s delay)
  };

  const [hover, setHover] = useState(false);

  return (

    <Card
      as={motion.div}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      whileHover={{
        scale: 1.02,
        boxShadow: "0px 10px 20px rgba(0, 0, 0, 0.15)",
      }}
      className="shadow-sm"
      style={{
        cursor: "pointer",
        padding: 0,
        margin: 0,
        overflow: "hidden",
        background: "#F8F9FA", // Soft light background
        border: "1px solid #dee2e6",
        borderRadius: "10px",
        transition: "all 0.3s ease-in-out",
      }}
    >
      {/* Product Image */}
      <motion.img
        src={product.image ? product.image : 'default_480x320.png'}
        alt={product.name}
        style={{
          height: "400px",
          objectFit: "cover",
          borderRadius: "10px 10px 0 0",
        }}
        whileHover={{ scale: 1.09 }} // Slight zoom effect on hover
        transition={{ duration: 0.3 }}
      />

      {/* Product Name */}
      <Card.Header
        className="bg-white text-dark"
        style={{
          borderBottom: "1px solid #ddd",
          fontSize: 15,
          maxHeight: "30px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          fontWeight: "bold",
        }}
      >
        {product.name || <span style={{ opacity: 0 }}>10</span>}
      </Card.Header>

      {/* Card Body */}
      <Card.Body style={{ maxHeight: "12rem", overflow: "hidden" }}>
        {/* Alias Name */}
        <Card.Text style={{
          fontSize: 13,
          color: "#6c757d",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }}>
          {product.alias_name}
        </Card.Text>

        {/* Product Type */}
        <Card.Text style={{
          fontSize: 13,
          fontWeight: "500",
          color: "#495057",
          marginBottom: "0.1rem",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }}>
          {product.typeProductString || <span style={{ opacity: 0 }}>10</span>}
        </Card.Text>

        {/* Pricing */}
        <motion.div
          initial={{ scale: 0.95 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.3, ease: "easeInOut" }}
        >
          <Card.Text style={{
            fontSize: 14,
          }}>Rp&nbsp;
            {product.promo_price ? (
              <>
                <span style={{ textDecoration: "line-through", color: "#dc3545", marginRight: "8px" }}>
                  {product.starting_price}
                </span>
                <span style={{
                  fontSize: 14,
                  fontWeight: "bold",
                  color: "#28a745", // Green price color
                }}>{product.promo_price}</span>
              </>
            ) : (
              <span>{product.starting_price}</span>
            )}
          </Card.Text>
        </motion.div>

        {/* Buttons */}
        <ButtonCard
          product={product}
          onAddToFavorites={onAddToFavorites}
          onAddToCart={onAddToCart}
          handleDetailClick={handleDetailClick}
        />
      </Card.Body>
    </Card>


  );
};

export default ProductCategoryCard;
